import 'leaflet/dist/leaflet.css';

import './index.scss';
import App from './components/App';

export default App;
